/**
 * 打字指示器组件
 */

import React from 'react';
import type { Character } from '../../../types';

interface GameTypingIndicatorProps {
  speaker: Character;
  charA: Character;
}

export const GameTypingIndicator: React.FC<GameTypingIndicatorProps> = React.memo(({ speaker, charA }) => {
  const isLeft = speaker.id === charA.id;
  return (
    <div className={`flex w-full mb-4 ${isLeft ? 'justify-start' : 'justify-end'}`}>
      {isLeft && (
        <img src={speaker.avatar} className="w-10 h-10 rounded-full shadow-sm mr-2 self-end shrink-0" alt={speaker.name} />
      )}
      <div
        className={`px-4 py-3 rounded-2xl ${isLeft
            ? 'bg-white border border-[#E5E0D8] rounded-bl-sm'
            : 'bg-[#FFE0E0] rounded-br-sm'
          }`}
      >
        <div className="flex gap-1">
          <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B6B]/40 animate-bounce" style={{ animationDelay: '0ms' }} />
          <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B6B]/40 animate-bounce" style={{ animationDelay: '150ms' }} />
          <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B6B]/40 animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
      {!isLeft && (
        <img src={speaker.avatar} className="w-10 h-10 rounded-full shadow-sm ml-2 self-end shrink-0" alt={speaker.name} />
      )}
    </div>
  );
});

GameTypingIndicator.displayName = 'GameTypingIndicator';
